import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import Header from '../../components/header';
import LeftNav from '../../components/left-nav';
import Home from '../home/home';
import User from '../user/user';
import Role from '../role/role';
import PRO from '../pro/pro';
import Test from '../test/test';
import Category from '../category/category';
import Categories from '../categories/categories';
import Client from '../client/client';

import NotFound from '../not-found/not-found';
import { connect } from 'react-redux';

import './admin.css';

const { Sider, Content } = Layout;
class Admin extends Component {
  componentDidMount() {
    document.title = '后台管理系统';
  }
  render() {
    const user = this.props.user;
    if (!user || !user.uid) {
      return <Redirect to='/login'></Redirect>;
    }
    return (
      <Layout style={{ minHeight: '100%' }}>
        <Sider>
          <LeftNav />
        </Sider>
        <Layout className='core-content'>
          <Header>Header</Header>
          <Content style={{ margin: '20px', backgroundColor: '#fff', flex: 1 }}>
            <Switch>
              <Route
                path='/admin/home'
                component={Home}
              />
              <Route
                path='/admin/role'
                component={Role}
              />
              <Route
                path='/admin/user'
                component={User}
              />
              <Route
                path='/admin/industry'
                component={PRO}
              />
              <Route
                path='/admin/category'
                component={Categories}
              />
              <Route
                path='/admin/series'
                component={Category}
              />
              <Route
                path='/admin/test/'
                component={Test}
              />
              <Route
                path='/admin/client'
                component={Client}
              />

              <Redirect
                from='/admin'
                to='/admin/home'
                exact
              />
              <Route component={NotFound}></Route>
            </Switch>
          </Content>
          {/* <Footer style={{ textAlign: 'center'}}>
            映翰通网络©2022 All Rights Reserved
          </Footer> */}
        </Layout>
      </Layout>
    );
  }
}

export default connect(state => ({ user: state.user }))(Admin);
